import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, switchMap, take } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AutomatedTestService {
    private http = inject(HttpClient);
    private authService = inject(AuthService);

    
    sendCsvFileToApi(file: File, targetEnvironment: 'dev' | 'stg' | 'prd'): Observable<any> {
        return this.authService.user$.pipe(
            take(1),
            switchMap(user => {
                if (!user || !user.email) {
                    throw new Error('No se pudo obtener el email del usuario');
                }

                const envConfig = environment.automatedTesting[targetEnvironment];
                const headers = new HttpHeaders({
                    'Content-Type': 'text/csv',
                    'x-api-key': envConfig.apiKey,
                    'user-email': user.email
                });

                return new Observable(observer => {
                    const reader = new FileReader();
                    reader.onload = () => {
                        const csvContent = reader.result as string;
                        this.http.post(envConfig.apiUrl, csvContent, { headers, responseType: 'text' })
                        .subscribe({
                            next: (res) => { observer.next(res); observer.complete(); },
                            error: (err) => observer.error(err)
                        });
                    };
                    reader.onerror = (err) => observer.error(err);
                    reader.readAsText(file);
                });
            })
        );
    }
}